export default __webpack_public_path__ + "static/media/Slide2.1a7ad210.png";